	
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue'
window.Vue = Vue;

import {default as Vuedals, Component as Vuedal, Bus as VuedalsBus} from 'vuedals';
Vue.use(Vuedals, Vuedal, VuedalsBus);

import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import Multiselect from 'vue-multiselect';
const { Dropzone } = require('dropzone');
Dropzone.autoDiscover = false;


import store from '../../vendor/anthology/shop/src/resources/assets/js/store';

Vue.component('multiselect', Multiselect);

Vue.component('select2', require('./components/lib/Select2.vue').default);
Vue.component('datepicker', require('./components/lib/DatePicker.vue').default);
Vue.component('datepicker2', require('./components/lib/DatePicker2.vue').default);
Vue.component('SwmButton', require('./components/lib/Button.vue').default);
Vue.component('example', require('./components/Example.vue').default);
Vue.component('attendance', require('./components/Attendance.vue').default);
Vue.component('member-attendance', require('./components/MemberAttendance.vue').default);
Vue.component('attendance_sheet', require('./components/AttendanceSheet.vue').default);
Vue.component('performance-chart', require('./components/PerformanceChart.vue').default);
Vue.component('make-payment', require('./components/MakePayment.vue').default);
Vue.component('club-records-page', require('./components/ClubRecordsPage.vue').default);
Vue.component('club-records-list', require('./components/ClubRecordsList.vue').default);
Vue.component('create-club-record', require('./components/CreateClubRecord.vue').default);
Vue.component('age-group-select', require('./components/AgeGroupSelect.vue').default);
Vue.component('gender-select', require('./components/GenderSelect.vue').default);
Vue.component('member-select', require('./components/MemberSelect.vue').default);
Vue.component('workout-select', require('./components/Workouts/WorkoutSelect').default);
Vue.component('member-select2', require('./components/MemberSelect2.vue').default);
Vue.component('course-select', require('./components/CourseSelect.vue').default);
Vue.component('event-select', require('./components/EventSelect.vue').default);
Vue.component('account-dashboard-balance', require('./components/AccountBalance.vue').default);
Vue.component('meet-entry-accepted-toggle', require('./components/MeetEntryEventAccepted.vue').default);
Vue.component('meet-entry-event-status', require('./components/MeetEntryEventStatus.vue').default);
Vue.component('team-member-toggle', require('./components/TeamMemberToggle.vue').default);
Vue.component('meet-events-list', require('./components/MeetEventsList.vue').default);
Vue.component('relay-entries', require('./components/RelayEntries.vue').default);
Vue.component('club-policy-acceptance', require('./components/ClubPolicyAcceptance.vue').default);
Vue.component('page-help-widget', require('./components/PageHelpWidget.vue').default);
Vue.component('document-library', require('./components/DocumentLibraryManager.vue').default);
Vue.component('media-attachment', require('./components/MediaAttachment.vue').default);
Vue.component('media-image', require('./components/MediaImage.vue').default);
Vue.component('group-list', require('./components/Group/GroupList.vue').default);
Vue.component('groups-page', require('./components/Group/GroupsPage.vue').default);
Vue.component('new-group-form', require('./components/Group/NewGroupForm.vue').default);
Vue.component('edit-group-form', require('./components/Group/EditGroupForm.vue').default);
Vue.component('member-medical-popup', require('./components/MemberMedicalPopup.vue').default);
Vue.component('training-set-page', require('./components/TrainingSets/TrainingSetsPage.vue').default);
Vue.component('training-set-form', require('./components/TrainingSets/TrainingSetForm.vue').default);
Vue.component('training-set-list', require('./components/TrainingSets/TrainingSetList.vue').default);

Vue.component('workouts-page', require('./components/Workouts/WorkoutsPage.vue').default);
Vue.component('workout-form', require('./components/Workouts/WorkoutForm.vue').default);
Vue.component('workout-list', require('./components/Workouts/WorkoutList.vue').default);

// Vue.component('registration-form', require('./components/Registration/RegistrationForm.vue').default);
Vue.component('account-review', require('./components/Accounts/AccountReview.vue').default);
Vue.component('validate-registered-members', require('./components/Members/ValidateRegisteredMembers').default);
Vue.component('text-reader', require('./components/utils/TextFileReader').default);
Vue.component('file-uploader', require('./components/utils/FileUploader').default);
Vue.component('credit-card', require('./components/utils/CreditCard').default);
Vue.component('rankings-pbs', require('./components/Members/UpdatePBs').default);
Vue.component('swimmanager-invoices', require('./components/Club/SwimManagerInvoices').default);
Vue.component('session-signup', require('./components/MemberTrainingSessions/SessionSignup').default);
Vue.component('pay-invoice', require('./components/Invoices/PayInvoice').default);
Vue.component('whats-new', require('./components/utils/WhatsNew').default);
Vue.component('help-button', require('./components/utils/HelpButton').default);

Vue.component('dataloader', require('./features/dataloader/DataLoader').default);

Vue.component('new-invoice', require('./pages/club/invoices/NewInvoice.vue').default);
Vue.component('enquiry-form', require('./components/Website/EnquiryForm.vue').default);

Vue.component('financial-accounts-list', require('./components/FinancialAccounts/FinancialAccountsList.vue').default);
Vue.component('financial-account-form', require('./components/FinancialAccounts/FinancialAccountForm.vue').default);

require('../../anthology/shop/src/resources/assets/js/components.js');
require('../../anthology/newsfeed/src/resources/assets/js/components.js');
require('../../anthology/volunteer/src/resources/assets/js/components.js');


window.eventBus = new Vue(); // https://laracasts.com/series/lets-build-a-forum-with-laravel/episodes/29 timecode 8:30

const app = new Vue({
    el: '#app',
    store
});

